import React from 'react';
import PropTypes from 'prop-types';

import { ConfirmModal, AlertTriangleFillIcon, Typography } from '@metarouter-private/mr-mui';

const MODAL_CONFIG = {
  title: 'Unsaved Changes',
  TitleIcon: AlertTriangleFillIcon,
  confirmLabel: 'Load',
  cancelLabel: 'Cancel',
};

export default function ConfirmLoadModal({ open, onConfirm, onClose }) {
  return (
    <ConfirmModal
      {...MODAL_CONFIG}
      open={open}
      onConfirm={onConfirm}
      onClose={onClose}
      message={
        <Typography>
          Loading the selected event will overwrite the current content. Are you sure you want to continue?
        </Typography>
      }
    />
  );
}

ConfirmLoadModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
